// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mobile-blocked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14.818 15.182C16.5754 16.9393 19.4246 16.9393 21.182 15.182C22.9393 13.4246 22.9393 10.5754 21.182 8.81802C19.4246 7.06066 16.5754 7.06066 14.818 8.81802C13.0607 10.5754 13.0607 13.4246 14.818 15.182Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 20V22H5V2H19V4M12 18H12.0039V18.0039H12V18Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.4749 9.52514L15.5251 14.4749M21.182 15.182C19.4246 16.9393 16.5754 16.9393 14.818 15.182C13.0607 13.4246 13.0607 10.5754 14.818 8.81802C16.5754 7.06066 19.4246 7.06066 21.182 8.81802C22.9393 10.5754 22.9393 13.4246 21.182 15.182Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MobileBlockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mobile-blocked',
    ref,
    icon: element,
  },
));

MobileBlockedIcon.displayName = 'MobileBlockedIcon';

export default MobileBlockedIcon;
